var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwiperprev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2705_1529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.222 415.948L572.61 793.336C581.496 802.221 595.746 802.221 604.632 793.336C613.517 784.45 613.517 770.2 604.632 761.314L243.339 400.021L604.632 38.7279C613.517 29.8423 613.517 15.5918 604.632 6.70613C600.273 2.34714 594.405 -4.25553e-06 588.705 -4.25553e-06C583.004 -4.25553e-06 577.137 2.17949 572.778 6.70613L195.39 384.094C186.504 392.812 186.504 407.23 195.222 415.948Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2705_1529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 800,
    fill: "white",
    transform: "matrix(-1 0 0 -1 800 800)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiperprev);
export default __webpack_public_path__ + "static/media/swiperprev.7b697ed2084f6a903ce2ac1f280640b7.svg";
export { ForwardRef as ReactComponent };